import React from 'react';
import { FaMusic, FaTimes } from 'react-icons/fa';
import { useT } from '../../../contexts/LocaleContext.jsx';

import '../../../styles/partial/SongRecommendationNotification.css';

const SongRecommendationNotification = ({ recommendation, onDismiss }) => {
  const t = useT();

  if (!recommendation) {
    return null;
  }

  const { title, artist, requestedBy } = recommendation;

  return (
    <div
      className="song-rec-notification"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <FaMusic className="song-rec-icon" aria-hidden="true" />
      <div className="song-rec-body">
        <span className="song-rec-label">{t('stream.recommendation.label')}</span>
        <span className="song-rec-title">{title}</span>
        {artist && <span className="song-rec-artist">{artist}</span>}
        {requestedBy && (
          <span className="song-rec-requested">{t('stream.requestedBy', { name: requestedBy })}</span>
        )}
      </div>
      <button
        type="button"
        className="song-rec-dismiss"
        onClick={onDismiss}
        aria-label={t('stream.recommendation.dismiss')}
      >
        <FaTimes aria-hidden="true" />
      </button>
    </div>
  );
};

export default SongRecommendationNotification;
